import OrganisationFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => (
  <GenericEditForm formLayoutComponent={<OrganisationFormLayout />} transformValues={transformValues} />
)
